module.exports = __webpack_public_path__ + "img/cloudview_drinks-menu.0cdd8909.jpg";